import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import QuestionText from '../components/QuestionText';
import Alert from '@material-ui/lab/Alert';
import FormControl from '@material-ui/core/FormControl';
import Button from '../../../components/Button.js';
import TextField from '@material-ui/core/TextField';
import * as EmailValidator from 'email-validator';
import { parsePhoneNumberFromString } from 'libphonenumber-js';

const item = 'contact';
const question = 'Lastly, please provide your contact details.';

const useStyles = makeStyles(theme => ({
  formControls: {
    maxWidth: '30rem',
  },
  formControl: {
    width: '100%',
    margin: 0,
    marginBottom: '1rem',
    backgroundColor: theme.palette.common.white,
  },
  button: {
    padding: '1.5rem 0',
    display: 'flex',
    justifyContent: 'center',
  },
}));

const ContactDetailsQuestion = ({data, handleAnswer}) => {
  const classes = useStyles();
  const [errors, setErrors] = React.useState({});
  const [firstName, setFirstName] = React.useState(data.contact.first_name);
  const [lastName, setLastName] = React.useState(data.contact.last_name);
  const [phone, setPhone] = React.useState(data.contact.phone);
  const [email, setEmail] = React.useState(data.contact.email);

  const validateForm = () => {
    const phoneNumber = parsePhoneNumberFromString(phone, 'AU');
    const errors = {
      firstName: firstName.length < 2 && 'First name must have at least 2 characters.',
      lastName: lastName.length < 2 && 'Last name must have at least 2 characters.',
    };
    if (phone === '' || (!phoneNumber || !phoneNumber.isValid())) {
      errors.phone = 'You must provide a valid phone number.';
    }
    if (email === '' || !EmailValidator.validate(email)) {
      errors.email = 'You must provide a valid email address.';
    }
    setErrors(errors);
    const valid = !Object.values(errors).some(v => v);
    return valid;
  };

  const handleSubmit = () => {
    if (validateForm()) {
      const data = {
        'first_name': firstName,
        'last_name': lastName,
        'phone': phone,
        'email': email
      };
      handleAnswer(item, data);
    }
  };

  return (
    <React.Fragment>
      <QuestionText>
        {question}
      </QuestionText>
      <div className={classes.formControls}>
        <FormControl className={classes.formControl}>
          <TextField
            required
            error={!!errors.firstName}
            placeholder="First name"
            label="First name"
            variant="outlined"
            value={firstName}
            onChange={e => setFirstName(e.target.value)}
          />
          {errors.firstName && <Alert severity="error">{errors.firstName}</Alert>}
        </FormControl>
        <FormControl className={classes.formControl}>
          <TextField
            required
            error={!!errors.lastName}
            placeholder="Last name"
            label="Last name"
            variant="outlined"
            value={lastName}
            onChange={e => setLastName(e.target.value)}
          />
          {errors.lastName && <Alert severity="error">{errors.lastName}</Alert>}
        </FormControl>
        <FormControl className={classes.formControl}>
          <TextField
            required
            error={!!errors.email}
            placeholder="Email"
            label="Email"
            variant="outlined"
            value={email}
            onChange={e => setEmail(e.target.value)}
          />
          {errors.email && <Alert severity="error">{errors.email}</Alert>}
        </FormControl>
        <FormControl className={classes.formControl}>
          <TextField
            required
            error={!!errors.phone}
            placeholder="Phone number"
            label="Phone number"
            variant="outlined"
            value={phone}
            onChange={e => setPhone(e.target.value)}
          />
          {errors.phone && <Alert severity="error">{errors.phone}</Alert>}
        </FormControl>
      </div>
      <div className={classes.button}>
        <Button
          onClick={handleSubmit}
          label="Next"
          pointer="right"
          variant="contained"
        />
      </div>
    </React.Fragment>
  );
};

ContactDetailsQuestion.propTypes = {
  data: PropTypes.object.isRequired,
  handleAnswer: PropTypes.func.isRequired,
};

export default ContactDetailsQuestion;
